export default "__VITE_ASSET__Cgd$P$nH__"